import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'
import { GetConfigAlertsResponse } from './typings/configAlertsTypings'

export const CONFIG_ALERTS_QUERY_KEY = 'config-alerts'

export function useGetConfigAlerts(programId?: string) {
  return useQuery({
    queryKey: [CONFIG_ALERTS_QUERY_KEY, programId],
    queryFn: async () => {
      const { data } = await apiClient.post<GetConfigAlertsResponse>(
        `/int/v3/program-alerts/${programId}/check`
      )
      return data
    },
    enabled: Boolean(programId),
    refetchOnWindowFocus: false,
  })
}

export function useDismissAlerts(programId?: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (slugs: string[]) => {
      await Promise.all(
        slugs.map((slug) => apiClient.post(`/int/v3/program-alerts/${programId}/${slug}/dismiss`))
      )
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CONFIG_ALERTS_QUERY_KEY, programId] })
    },
  })
}
